// Parité fixe BCEAO : 1 EUR = 655,957 XOF. XOF n'a pas de décimales.
export function euroToXofAmount(euroPrice) {
  const euros = parseFloat(String(euroPrice == null ? '' : euroPrice).replace(/[^\d.]/g, ''));
  if (!Number.isFinite(euros) || euros < 0) return '0';
  const cents = Math.round(euros * 100);
  return String(Math.round((cents * 655957) / 100000));
}
